<template>
  <button
    :class="`button ${type}`"
    :data-loading="loading"
    @click="$emit('click')"
  >
    <slot />

  </button>
</template>

<script>
export default {
  name: "base-button",
  props: {
    type: {
      default: "primary",
      type: String
    },
    loading: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/base-components/base-button.vue